import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IArchiveParams, IGetArchive, IGetArchives } from '../models/homepageManagementStudyArchive.model';
import QueryString from 'qs';

const uri = '/mgmt/homepage-management/study-archive';

export const getArchives = (params: IArchiveParams): AxiosPromise<IGetArchives> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
};

export const getArchive = (archiveCode: number): AxiosPromise<IGetArchive> => {
  return axios.get(`${uri}/${archiveCode}`);
};

export const createArchive = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateArchive = (archiveCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${archiveCode}`, data);
};

export const deleteArchive = (archiveCode: number): AxiosPromise => {
  return axios.delete(`${uri}/remove/${archiveCode}`);
};
